<template>
	<div>
		<b-form-group horizontal
    label="Nom:"
    label-class="text-sm-right"
    label-for="lastname">
    	<b-form-input id="lastname" v-model="lastname"></b-form-input>
    </b-form-group>
    <b-form-group horizontal
    label="Prenom:"
    label-class="text-sm-right"
    label-for="firstname">
    	<b-form-input id="firstname" v-model="firstname"></b-form-input>
    </b-form-group>
    <div slot="modal-footer" class="w-100">
    	<b-button variant="primary" @click="addNewUser">Ajouter <img :src="hi"></b-button>
    </div>
	</div>
</template>
<script>
import { hellIcon } from '../../assets/icons/icons.js';
export default {
	name: 'ModalAddUser',
	data: () => ({
		hi: '',
		lastname: '',
		firstname: ''
	}),
	mounted() {
		this.hi = hellIcon;
	},
	methods: {
		addNewUser() {
			let user = { lastname: this.lastname, firstname: this.firstname };
			this.$emit('addNewUser', user);
			// console.log(this.lastname, this.firstname);
		}
	}
};
</script>
<style lang="scss">
</style>
